/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react";
import FullPageLayout from "../../../templates/FullPageLayout";
import Header from "./Components/Header";
import { NeedHelp } from "../../../atoms/CustomIcons";
import { Button, Card, Col, Dropdown, Image, Row } from "antd";
import { MoreOutlined } from "@ant-design/icons";
import { useAppDispatch, useAppSelector } from "../../../config/hooks";
import { PopUp } from "../../../atoms/PopUp";
import CatalogueModal from "./Components/CatalogueModal";
import {
  getPotentialDealDetails,
  getProposalById,
  getProposalDetailById,
  getProposalFormData,
  removeProposalById,
} from "../ducks/actions";
import { saveProposal } from "../ducks/services";
import {
  ServiceLineType,
  SubmitEstimateType,
  SubmitServiceLinesType,
  SubServiceType,
} from "../ducks/types";
import { AxiosError, AxiosResponse } from "axios";
import ErrorMessage from "../../../atoms/Toasts/ErrorMessage";
import SuccessMessage from "../../../atoms/Toasts/SuccessMessage";
import ChooseServiceLine from "./Components/ChooseServiceLine";
import { useNavigate } from "react-router-dom";
import EstimateSidebar from "./Components/Sidebar";
import { calculateServiceIntervals } from "./Components/Utils";
import EstimateDropDown from "./Components/Dropdown";
import EstimateServices from "./Components/EstimateServices";
import EmptyCard from "../../../atoms/EmptyCard";

export default function Estimate() {
  const [loading, setLoading] = useState(false);
  const [catalogueModalVisible, setCatalogueModalVisible] = useState(false);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const locationUrl = window.location.pathname;
  const pathSegments = locationUrl.split("/");
  const companyId = pathSegments[pathSegments.length - 1];
  const estimateId = pathSegments[pathSegments.length - 2];
  const proposalId = pathSegments[pathSegments.length - 3];
  // const [activeId, setActiveId] = useState<null | string>(null);
  const [activeServiceLineId, setActiveServiceLineId] = useState<null | string>(
    null
  );
  const [activeRecord, setActiveRecord] = useState<SubServiceType | null>(null);
  const [activeType, setActiveType] = useState<null | string>(null);
  const [activeServiceId, setActiveServiceId] = useState<null | string>(null);
  // console.log("pathSegments--", activeRecord, activeType, activeServiceLineId);
  const [combineDropDown, setCombineDropDown] = useState<any[]>([]);
  const [textAreaContent, setTextAreaContent] = useState("");
  const proposalDetailData = useAppSelector(
    (state) => state?.potentialDeal?.proposalDetailData
  );
  const estimateFormData = useAppSelector(
    (state) => state?.potentialDeal?.estimateFormData
  );

  const proposalData = useAppSelector(
    (state) => state?.potentialDeal?.proposalData
  );
  const dealsDetailData = useAppSelector(
    (state) => state?.potentialDeal?.dealsDetailData
  );

  const items = [
    {
      key: "1",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/estimate/sorting.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          Sort services
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/estimate/refresh.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          Sync material costs with inventory
        </Button>
      ),
    },
    {
      key: "3",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/estimate/reset.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          Reset all numbers to default
        </Button>
      ),
    },
  ];

  useEffect(() => {
    if (companyId) {
      dispatch(getProposalFormData(companyId));
    }
  }, [dispatch, companyId]);

  useEffect(() => {
    dispatch(removeProposalById(pathSegments.length === 5));
  }, [dispatch]);

  const cataloguePopUp = {
    visibility: catalogueModalVisible,
    class: "upload_photo_modal select_service_popup",
    content: <CatalogueModal onClose={() => setCatalogueModalVisible(false)} />,
    width: 1552,
    onCancel: () => setCatalogueModalVisible(false),
  };

  const [selectedServiceIds, setSelectedServiceIds] = useState<string[]>([]);
  const [groupedData, setGroupedData] = useState<any[]>([]);
  const [showServicePopUp, setShowServicePopUp] = useState<boolean>(false);
  const [serviceLineForLineItems, setServiceLineForLineItems] =
    useState<ServiceLineType | null>(null);

  const createPlaceholderLineItem = () => ({
    name: "",
    total_cost: 1,
    total_price: 50,
    gross_margin_perc: 50,
  });

  // function mergeDeepServiceLine(existing: any, incoming: any) {
  //   console.log("existing", existing, incoming);
  //   return {
  //     ...incoming,
  //     line_items: existing.line_items ?? incoming.line_items,
  //     service_groups: incoming.service_groups?.map((group: any) => {
  //       const existingGroup = existing.service_groups?.find(
  //         (g: any) => g.id === group.id
  //       );
  //       return {
  //         ...group,
  //         services: group.services?.map((srv: any) => {
  //           const existingSrv = existingGroup?.services?.find(
  //             (s: any) => s.entity_id === srv.entity_id
  //           );
  //           return {
  //             ...srv,
  //             ...existingSrv, // this keeps the previous changes like qty, cost, etc.
  //           };
  //         }),
  //       };
  //     }),
  //     services: incoming.services?.map((srv: any) => {
  //       const existingSrv = existing.services?.find(
  //         (s: any) => s.entity_id === srv.entity_id
  //       );
  //       return {
  //         ...srv,
  //         ...existingSrv,
  //       };
  //     }),
  //   };
  // }

  function mergeDeepServiceLine(existing: any, incoming: any) {
    const existingGroups = Array.isArray(existing.service_groups)
      ? existing.service_groups
      : [];
    const incomingGroups = Array.isArray(incoming.service_groups)
      ? incoming.service_groups
      : [];

    const existingServices = Array.isArray(existing.services)
      ? existing.services
      : [];
    const incomingServices = Array.isArray(incoming.services)
      ? incoming.services
      : [];

    const mergedServiceGroups = incomingGroups.map((group: any) => {
      const existingGroup = existingGroups.find((g: any) => g.id === group.id);
      return {
        ...group,
        services:
          group.services?.map((srv: any) => {
            const existingSrv = existingGroup?.services?.find(
              (s: any) => s.entity_id === srv.entity_id
            );
            return {
              ...srv,
              ...existingSrv,
            };
          }) ?? [],
      };
    });

    // Merge services
    const mergedServices = incomingServices.map((srv: any) => {
      const existingSrv = existingServices.find(
        (s: any) => s.entity_id === srv.entity_id
      );
      return {
        ...srv,
        ...existingSrv,
      };
    });

    return {
      ...incoming,
      line_items: existing.line_items ?? incoming.line_items,
      service_groups: mergedServiceGroups.length ? mergedServiceGroups : [],
      services: mergedServices.length ? mergedServices : [],
    };
  }

  const handleEstimateData = () => {
    const transformServiceArray = estimateFormData?.services?.filter(
      (service) => selectedServiceIds.includes(service.id)
    );

    const transformServiceLineArray = estimateFormData?.service_lines?.filter(
      (serviceLine) =>
        transformServiceArray?.some(
          (service) => service.service_line_id === serviceLine.id
        )
    );

    const transformServiceGroupArray = estimateFormData?.service_groups?.filter(
      (serviceGroup) =>
        transformServiceArray?.some(
          (service) => service.parent_id === serviceGroup.id
        )
    );

    const transformServiceDataArray = transformServiceArray?.filter(
      (service) => !service?.parent_id
    );

    const newGroupedData: any = (transformServiceLineArray ?? []).map(
      (serviceLine, index) => {
        return {
          service_line_id: serviceLine.id,
          name: serviceLine.name,
          color: serviceLine.color,
          labor_rate: serviceLine?.labor_rate || 0,
          total_cost: 0,
          total_price: 0,
          gross_margin_perc: 0,
          index: index + 1,
          service_groups:
            (transformServiceGroupArray ?? [])?.length > 0
              ? (transformServiceGroupArray ?? [])
                  .filter(
                    (serviceGroup) =>
                      serviceGroup.service_line_id === serviceLine.id
                  )
                  .map((serviceGroup, ind) => ({
                    id: serviceGroup.id,
                    name: serviceGroup.name,
                    complexity: 0,
                    hrs_per_visit: 0,
                    total_cost: 0,
                    total_price: 0,
                    gross_margin_perc: 0,
                    index: ind + 1,
                    services:
                      (transformServiceArray ?? [])
                        .filter(
                          (service) =>
                            service.service_line_id === serviceLine.id
                        )
                        .filter(
                          (service) => service.parent_id === serviceGroup.id
                        )?.length > 0
                        ? (transformServiceArray ?? [])
                            .filter(
                              (service) =>
                                service.service_line_id === serviceLine.id
                            )
                            .filter(
                              (service) => service.parent_id === serviceGroup.id
                            )
                            .map((service, i) => ({
                              index: i + 1,
                              frequency: service?.frequency || "",
                              entity_id: service.id,
                              name: service.name,
                              qty: 0,
                              prod_rate: service?.production_rate || 0,
                              hrs_per_visit: 0,
                              labor_hrs: 0,
                              labor_price: 0,
                              total_labor_cost: 0,
                              total_labor_price: 0,
                              total_material_cost: 0,
                              total_material_price: 0,
                              total_cost: 0,
                              total_price: 0,
                              unit: service?.unit?.singular_name
                                ? service?.unit?.singular_name
                                : service?.takeoff?.unit?.singular_name || "",
                              labor_gross_margin_perc: 0,
                              material_gross_margin_perc: 0,
                              gross_margin_perc: 0,
                              image_url: service?.image_url || "",
                              no_of_materials:
                                service?.serviceMaterials?.length || 0,
                              who_performs: service?.service_provision_type,
                              visit:
                                service?.frequency === "one_time"
                                  ? 1
                                  : dealsDetailData?.data?.start_date &&
                                    dealsDetailData?.data?.end_date &&
                                    service?.frequency &&
                                    Math.round(
                                      calculateServiceIntervals(
                                        dealsDetailData?.data?.start_date,
                                        dealsDetailData?.data?.end_date,
                                        service?.frequency
                                      )
                                    ),
                              material: (service?.serviceMaterials || []).map(
                                (material, matInd) => ({
                                  index: matInd + 1,
                                  id: material.id,
                                  name: material.material?.name,
                                  use_rate: material?.use_rate || 0,
                                  total_need: 0,
                                  unit_cost: material?.material?.cost ?? 0,
                                  unit_price: 0,
                                  total_cost: 0,
                                  total_price: 0,
                                  gross_margin_perc: 0,
                                  unit_order: material?.unit_order,
                                })
                              ),
                            }))
                        : undefined,
                  }))
              : undefined,
          services:
            (transformServiceDataArray ?? []).filter(
              (service) => service.service_line_id === serviceLine.id
            )?.length > 0
              ? (transformServiceDataArray ?? [])
                  .filter(
                    (service) => service.service_line_id === serviceLine.id
                  )
                  .map((service, i) => ({
                    index: i + 1,
                    frequency: service?.frequency || "",
                    entity_id: service.id,
                    name: service.name,
                    qty: 0,
                    prod_rate: service?.production_rate ?? 0,
                    hrs_per_visit: 0,
                    labor_hrs: 0,
                    labor_price: 0,
                    total_labor_cost: 0,
                    total_labor_price: 0,
                    total_material_cost: 0,
                    total_material_price: 0,
                    total_cost: 0,
                    total_price: 0,
                    labor_gross_margin_perc: 0,
                    unit: service?.unit?.singular_name
                      ? service?.unit?.singular_name
                      : service?.takeoff?.unit?.singular_name || "",
                    material_gross_margin_perc: 0,
                    gross_margin_perc: 0,
                    image_url: service?.image_url || "",
                    no_of_materials: service?.serviceMaterials?.length || 0,
                    who_performs: service?.service_provision_type,
                    visit:
                      service?.frequency === "one_time"
                        ? 1
                        : dealsDetailData?.data?.start_date &&
                          dealsDetailData?.data?.end_date &&
                          service?.frequency &&
                          Math.round(
                            calculateServiceIntervals(
                              dealsDetailData?.data?.start_date,
                              dealsDetailData?.data?.end_date,
                              service?.frequency
                            )
                          ),
                    material: (service?.serviceMaterials || []).map(
                      (material, matInd) => ({
                        index: matInd + 1,
                        id: material.id,
                        name: material.material?.name,
                        use_rate: material?.use_rate || 0,
                        total_need: 0,
                        unit_cost: material?.material?.cost ?? 0,
                        unit_price: 0,
                        total_cost: 0,
                        total_price: 0,
                        gross_margin_perc: 0,
                        unit_order: material?.unit_order,
                      })
                    ),
                  }))
              : undefined,
        };
      }
    );

    const mergedGroupedData: any[] = [];
    newGroupedData.forEach((newItem: any) => {
      const existingItem = groupedData.find(
        (g) => g.service_line_id === newItem.service_line_id
      );

      // console.log("existingItem", existingItem, newItem);

      if (existingItem) {
        mergedGroupedData.push(mergeDeepServiceLine(existingItem, newItem));
      } else {
        mergedGroupedData.push(newItem);
      }
    });

    // console.log("mergedGroupedData", mergedGroupedData);

    let finalGroupedData = [...mergedGroupedData]; // Create a new array reference

    if (serviceLineForLineItems) {
      const existingServiceLineIndex = finalGroupedData.findIndex(
        (item) => item.service_line_id === serviceLineForLineItems.id
      );

      if (existingServiceLineIndex !== -1) {
        // Case 1: Matching Service Line found - Add LineItem to its existing line_items array
        finalGroupedData = finalGroupedData.map((item, idx) => {
          if (idx === existingServiceLineIndex) {
            return {
              ...item,
              line_items: [
                // ...(item?.line_items || undefined), // Append to existing line items
                createPlaceholderLineItem(),
              ],
            };
          }
          return item;
        });
      } else {
        // Case 2: No matching Service Line found in the *merged* data.
        // This implies serviceLineForLineItems is completely new or wasn't part of estimateFormData's selection.
        const newServiceLineEntry: SubmitServiceLinesType = {
          service_line_id: serviceLineForLineItems.id,
          name: serviceLineForLineItems.name,
          color: serviceLineForLineItems.color,
          labor_rate: 0,
          total_cost: 0,
          total_price: 0,
          gross_margin_perc: 0,
          index:
            (finalGroupedData.length > 0
              ? Math.max(...finalGroupedData.map((d) => d.index))
              : 0) + 1, // Assign a unique index
          line_items: createPlaceholderLineItem()
            ? [createPlaceholderLineItem()]
            : undefined,
          service_groups: [],
          services: [],
        };
        finalGroupedData.push(newServiceLineEntry);
      }
    }
    setGroupedData(finalGroupedData);
    setServiceLineForLineItems(null); // Reset after processing
  };

  console.log("groupedData--", groupedData);

  // const sentProposalDocFunc = (id: string) => {
  //   setLoading(true);
  //   const payload = {
  //     proposal_id: id ?? "",
  //     companyId: companyId,
  //   };
  //   sentProposalDoc(payload)
  //     .then(() => {
  //       setLoading(false);
  //       navigate(`/editor/${id}/${estimateId}/${companyId}`);
  //     })
  //     .catch((e: unknown) => {
  //       if (e instanceof AxiosError) {
  //         setLoading(false);
  //         ErrorMessage(
  //           e?.response?.data?.error?.message ?? "Something went wrong"
  //         );
  //       } else {
  //         setLoading(false);
  //         ErrorMessage("Something went wrong");
  //       }
  //     });
  // };

  const handleSubmitEstimate = () => {
    setLoading(true);

    let calculatedTotalAmount = 0;
    let calculatedTotalCost = 0;
    // let totalServiceLineCost = 0;
    // let totalServiceLinePrice = 0;
    let totalSubServiceCost = 0;
    let totalSubServicePrice = 0;
    let hrsPerVisit = 0;

    groupedData?.forEach((groupData: any) => {
      // calculatedTotalAmount += groupData.total_price || 0;
      // calculatedTotalCost += groupData.total_cost || 0;
      // gmTotalMargin += groupData.gross_margin_perc * groupData.total_price || 0;

      (groupData?.service_groups ?? []).forEach((serviceGroup: any) => {
        serviceGroup?.services?.forEach((service: any) => {
          calculatedTotalAmount += service?.total_price || 0;
          calculatedTotalCost += service?.total_cost || 0;
          // totalServiceLineCost += service?.total_cost || 0;
          // totalServiceLinePrice += service?.total_price || 0;
          totalSubServiceCost += service?.total_cost || 0;
          totalSubServicePrice += service?.total_price || 0;
          // console.log(
          //   "service?.total_cost totalSubServiceCost",
          //   totalSubServiceCost
          // );
        });
      });

      // Calculate total cost from top-level services
      (groupData?.services ?? []).forEach((service: any) => {
        // totalServiceLineCost += service?.total_cost || 0;
        // totalServiceLinePrice += service?.total_price || 0;
        calculatedTotalAmount += service?.total_price || 0;
        calculatedTotalCost += service?.total_cost || 0;
      });
    });

    let grossMargin = 0;
    if (calculatedTotalAmount && calculatedTotalCost) {
      grossMargin = parseFloat(
        Number(
          ((calculatedTotalAmount - calculatedTotalCost) /
            calculatedTotalAmount) *
            100
        ).toFixed(1)
      );
    }
    // console.log("totalSubServiceCost", totalSubServiceCost);

    const SALES_TAX_PERCENTAGE = 8.5;
    const salesTaxTotalAmount =
      calculatedTotalAmount * (SALES_TAX_PERCENTAGE / 100);

    const totalAmountIncludingTax = calculatedTotalAmount + salesTaxTotalAmount;

    const payload: SubmitEstimateType = {
      deal_id: estimateId,
      company_id: companyId,
      proposal_id: pathSegments.length === 5 ? proposalId : undefined,
      gross_margin_perc: grossMargin || 0,
      total_amount: totalAmountIncludingTax || 0,
      labor_amount: 0,
      material_amount: 0,
      subcontractor_amount: 0,
      other_amount: 0,
      summary: textAreaContent ?? "",
      total_cost: calculatedTotalCost,
      sales_tax_perc: 0,
      total_price: calculatedTotalAmount || 0,
      sales_tax_total_amount: salesTaxTotalAmount,
      services_lines: groupedData?.map((groupData: any) => {
        return {
          ...groupData,
          total_price: calculatedTotalAmount || 0,
          total_cost: calculatedTotalCost || 0,

          service_groups: groupData?.service_groups?.map(
            (serviceGroup: any) => {
              return {
                ...serviceGroup,
                total_cost: totalSubServiceCost || 0,
                total_price: totalSubServicePrice || 0,
                services: serviceGroup?.services?.map((service: any) => {
                  const HourPerVisit = service?.qty / service?.prod_rate || 0;
                  const laborHours = HourPerVisit * service?.visit || 0;
                  hrsPerVisit += laborHours / service?.visit || 0;
                  return {
                    ...service,
                    hrs_per_visit: hrsPerVisit || 0,
                  };
                }),
              };
            }
          ),
        };
      }) as SubmitServiceLinesType[],
    };

    saveProposal(payload)
      .then(() => {
        setLoading(false);
        SuccessMessage(
          `Estimate ${pathSegments.length === 5 ? "updated" : "saved"}`
        );
        navigate(`/deals-detail/${estimateId}/${companyId}`);
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          setLoading(false);
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
        } else {
          setLoading(false);
          ErrorMessage("Something went wrong");
        }
      });
  };
  const handleSubmitProposalDoc = () => {
    setLoading(true);

    let calculatedTotalAmount = 0;
    let calculatedTotalCost = 0;
    // let totalServiceLineCost = 0;
    // let totalServiceLinePrice = 0;
    let totalSubServiceCost = 0;
    let totalSubServicePrice = 0;
    let hrsPerVisit = 0;

    groupedData?.forEach((groupData: any) => {
      // calculatedTotalAmount += groupData.total_price || 0;
      // calculatedTotalCost += groupData.total_cost || 0;
      // gmTotalMargin += groupData.gross_margin_perc * groupData.total_price || 0;

      (groupData?.service_groups ?? []).forEach((serviceGroup: any) => {
        serviceGroup?.services?.forEach((service: any) => {
          calculatedTotalAmount += service?.total_price || 0;
          calculatedTotalCost += service?.total_cost || 0;
          // totalServiceLineCost += service?.total_cost || 0;
          // totalServiceLinePrice += service?.total_price || 0;
          totalSubServiceCost += service?.total_cost || 0;
          totalSubServicePrice += service?.total_price || 0;
          // console.log(
          //   "service?.total_cost totalSubServiceCost",
          //   totalSubServiceCost
          // );
        });
      });

      // Calculate total cost from top-level services
      (groupData?.services ?? []).forEach((service: any) => {
        // totalServiceLineCost += service?.total_cost || 0;
        // totalServiceLinePrice += service?.total_price || 0;
        calculatedTotalAmount += service?.total_price || 0;
        calculatedTotalCost += service?.total_cost || 0;
      });
    });

    let grossMargin = 0;
    if (calculatedTotalAmount && calculatedTotalCost) {
      grossMargin = parseFloat(
        Number(
          ((calculatedTotalAmount - calculatedTotalCost) /
            calculatedTotalAmount) *
            100
        ).toFixed(1)
      );
    }
    // console.log("totalSubServiceCost", totalSubServiceCost);

    const SALES_TAX_PERCENTAGE = 8.5;
    const salesTaxTotalAmount =
      calculatedTotalAmount * (SALES_TAX_PERCENTAGE / 100);

    const totalAmountIncludingTax = calculatedTotalAmount + salesTaxTotalAmount;

    const payload: SubmitEstimateType = {
      deal_id: estimateId,
      company_id: companyId,
      proposal_id: pathSegments.length === 5 ? proposalId : undefined,
      gross_margin_perc: grossMargin || 0,
      total_amount: totalAmountIncludingTax || 0,
      total_price: calculatedTotalAmount || 0,
      labor_amount: 0,
      material_amount: 0,
      subcontractor_amount: 0,
      other_amount: 0,
      summary: textAreaContent ?? "",
      total_cost: calculatedTotalCost,
      sales_tax_perc: 0,
      sales_tax_total_amount: salesTaxTotalAmount,
      services_lines: groupedData?.map((groupData: any) => {
        return {
          ...groupData,
          total_price: calculatedTotalAmount || 0,
          total_cost: calculatedTotalCost || 0,

          service_groups: groupData?.service_groups?.map(
            (serviceGroup: any) => {
              return {
                ...serviceGroup,
                total_cost: totalSubServiceCost || 0,
                total_price: totalSubServicePrice || 0,
                services: serviceGroup?.services?.map((service: any) => {
                  const HourPerVisit = service?.qty / service?.prod_rate || 0;
                  const laborHours = HourPerVisit * service?.visit || 0;
                  hrsPerVisit += laborHours / service?.visit || 0;
                  return {
                    ...service,
                    hrs_per_visit: hrsPerVisit || 0,
                  };
                }),
              };
            }
          ),
        };
      }) as SubmitServiceLinesType[],
    };

    saveProposal(payload)
      .then(async (res: AxiosResponse) => {
        if (res && res?.data?.id) {
          setLoading(false);
          // sentProposalDocFunc(res?.data?.id);
          navigate(`/editor/${res?.data?.id}/${estimateId}/${companyId}`);
        }
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          setLoading(false);
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
        } else {
          setLoading(false);
          ErrorMessage("Something went wrong");
        }
      });
  };

  const chooseServiceLinePopUp = {
    visibility: showServicePopUp,
    class: "upload_photo_modal",
    content: (
      <ChooseServiceLine
        title=""
        onClose={() => setShowServicePopUp(false)}
        heading="Choose service line"
        paragraph="There are no service lines in this estimate. Select one to add the service to."
        btnText="Add line item"
        modalData={estimateFormData?.service_lines}
        setServiceLineForLineItems={setServiceLineForLineItems}
        btnApi={() => {
          handleEstimateData();
          setShowServicePopUp(false);
        }}
        loading={loading}
      />
    ),
    width: 540,
    onCancel: () => setShowServicePopUp(false),
  };

  useEffect(() => {
    if (proposalId && pathSegments.length === 5) {
      dispatch(getProposalById(proposalId));
      dispatch(getProposalDetailById(proposalId));
    }
  }, [proposalId, dispatch]);

  useEffect(() => {
    if (estimateId) {
      dispatch(getPotentialDealDetails(estimateId));
    }
  }, [dispatch, estimateId]);

  useEffect(() => {
    if (proposalDetailData?.summary) {
      setTextAreaContent(proposalDetailData?.summary || "");
    }
  }, [proposalDetailData]);
  // console.log("selectedServiceIds", selectedServiceIds);
  return (
    <FullPageLayout loading={loading || proposalData?.loader}>
      <div className="estimateWrapper">
        <Header
          companyId={companyId}
          estimateId={estimateId}
          btnText1="Need help?"
          btnIcon1={<NeedHelp />}
          btnText2="Proposal doc"
          setLoading={setLoading}
          dealsDetailData={dealsDetailData?.data}
          proposalDetailData={proposalDetailData}
          addProposal={true}
          handleSubmitEstimate={handleSubmitEstimate}
          handleSubmitProposalDoc={handleSubmitProposalDoc}
          proposalId={proposalId}
          dealId={estimateId}
        />

        <Card className="estimateCard">
          <Row gutter={16} wrap={false}>
            <Col flex="auto">
              <Card className="estimateCardInner">
                <div className="estimateLeftHeader">
                  <EstimateDropDown
                    handleEstimateData={handleEstimateData}
                    estimateFormData={estimateFormData}
                    proposalData={proposalData}
                    setGroupedData={setGroupedData}
                    combineDropDown={combineDropDown}
                    setCombineDropDown={setCombineDropDown}
                    setSelectedServiceIds={setSelectedServiceIds}
                    selectedServiceIds={selectedServiceIds}
                  />

                  {/* <Button
                    onClick={() => setCatalogueModalVisible(true)}
                    className="ant-btn-primary"
                  >
                    Choose from catalogue
                  </Button> */}
                  <Button
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowServicePopUp(true);
                    }}
                    icon={
                      <Image
                        src="/images/estimate/addMore.svg"
                        preview={false}
                      />
                    }
                    style={{ width: "36px", height: "36px" }}
                  />
                  <Dropdown
                    menu={{
                      items,
                    }}
                    trigger={["click"]}
                    placement="bottomRight"
                    className="actionButton"
                  >
                    <Button
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                      onKeyDown={(e) => e.stopPropagation()}
                      className="only_icon"
                      icon={<MoreOutlined />}
                      style={{ width: "36px", height: "36px" }}
                    />
                  </Dropdown>
                </div>

                {groupedData?.length > 0 ? (
                  <div className="estimateWrap">
                    {groupedData?.map((groupData: any, groupIndex: number) => {
                      return (
                        <EstimateServices
                          key={groupIndex}
                          setActiveRecord={setActiveRecord}
                          setActiveType={setActiveType}
                          groupData={groupData}
                          groupedData={groupedData}
                          groupIndex={groupIndex}
                          setGroupedData={setGroupedData}
                          companyId={companyId}
                          apiData={proposalData?.data}
                          setActiveServiceLineId={setActiveServiceLineId}
                          setActiveServiceId={setActiveServiceId}
                          selectedServiceIds={selectedServiceIds}
                          setSelectedServiceIds={setSelectedServiceIds}
                        />
                      );
                    })}
                  </div>
                ) : (
                  <div className="empty_wrap estimateEmptyCard">
                    <EmptyCard
                      imageHeight={200}
                      title="No services selected yet"
                      description={
                        <>
                          You haven’t added any services yet. Search for a
                          service or
                          <br /> Choose from catalogue to find what you need.
                        </>
                      }
                      image="/images/empty-icons/no-archived.svg"
                    />
                  </div>
                )}
              </Card>
            </Col>
            <Col flex="328px">
              <EstimateSidebar
                setLoading={setLoading}
                setTextAreaContent={setTextAreaContent}
                textAreaContent={textAreaContent}
                activeRecord={activeRecord}
                groupedData={groupedData}
                newEstimate={true}
                activeServiceId={activeServiceId}
                singleGroupData={groupedData?.find(
                  (e) => e?.service_line_id === activeServiceLineId
                )}
                activeType={activeType}
                resetSidebar={() => {
                  setActiveRecord(null);
                  setActiveType(null);
                  setActiveServiceLineId(null);
                }}
              />
            </Col>
          </Row>
        </Card>
      </div>
      <PopUp {...cataloguePopUp} />
      <PopUp {...chooseServiceLinePopUp} />
    </FullPageLayout>
  );
}
